var map = {
	"./1.svg": 65,
	"./100.svg": 66,
	"./13.svg": 67,
	"./2.svg": 68,
	"./20.svg": 69,
	"./3.svg": 70,
	"./40.svg": 71,
	"./5.svg": 72,
	"./8.svg": 73,
	"./back.svg": 39,
	"./infinite.svg": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;